<template>
  <v-list-item :disabled="item.addingToCart || !itemIsAvailableForOrdering">
    <v-list-item-content
      :id="`${itemTitle}-details`"
      :style="hideItemDetails ? '' : 'cursor: pointer;'"
      @click="showItemInFull(item)"
    >
      <v-list-item-title class="font-weight-medium pb-1">
        {{ itemTitle }}
      </v-list-item-title>
      <v-list-item-subtitle class="pb-4">
        <template v-if="lineItemHasSalePrice">
          <span :class="itemIsAvailableForOrdering ? 'text--primary' : 'text--disabled'">{{ currencyAsText(productSalePrice) }}</span>
          <span class="text--disabled text-decoration-line-through">{{ currencyAsText(basePrice) }}</span>
        </template>
        <template v-else>
          <span :class="itemIsAvailableForOrdering ? 'text--primary' : 'text--disabled'">{{ currencyAsText(basePrice) }}</span>
        </template>
      </v-list-item-subtitle>      
      <v-list-item-subtitle
        class="salescloud-item-description"
        style="color: #3F3B3B;"        
      >
      <div style="display: flex; align-items: flex-start;">
        <v-icon
          v-if="!itemIsAvailableForOrdering"
          color="#757575"
          size="16"
          class="mr-2"
        >mdi-information-outline</v-icon>
        <div v-html="itemDescription(item)" />
      </div>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-row
        align="center"
        dense
      >
        <v-col
          v-if="itemsInCart"
          class="caption grow"
          cols="auto"
        >
          {{ itemsInCart }} {{ $t('cart.inCart') }}
        </v-col>
      </v-row>
    </v-list-item-action>
    <v-list-item-avatar
      v-if="!hideListPictures"
      @click="showItemInFull(item)"
      class="align-self-center"
    >
      <v-img :src="getImage" />
    </v-list-item-avatar>
  </v-list-item>
</template>

<script>
    export default {
        name: "ListItem",
        props: {
            item: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            itemTitle() {
                return this.$store.getters.translateByType('item.title', this.item)
            },
            itemIsAvailableForOrdering() {
                return !this.itemIsBlockedByLocation
            },
            disableVariationSelection() {
                return this.$store.state.disableVariationSelection
            },
            itemsInCart() {
                return this.$store.getters.itemsInCart(this.item.uuid).length
            },
            primaryColor() {
                return this.$store.state.primaryColor
            },
            accentColor() {
                return this.$store.state.accentColor
            },
            hideListPictures() {
                return this.$store.state.hideListPictures
            },
            getImage() {
                return this.$store.getters.getThumbnailImage(this.item)
            },
            itemHasDescriptionValue() {
                return this.$store.getters.itemHasDescriptionValue(this.item)
            },
            itemHasVariations() {
                return this.$store.getters.itemHasVariations(this.item)
            },
            basePrice() {
                return this.$store.getters.itemBasePrice(this.item)
            },
            hideItemDetails() {
                return this.$store.state.hideItemDetails
            },
            lineItemHasSalePrice() {
                return this.$store.getters.itemHasSalePrice(this.item)
            },
            productSalePrice() {
                return this.$store.getters.productBaseSalePrice(this.item)
            },
            itemIsBlockedByLocation() {
                return this.$store.getters.productIsBlockedByLocation(this.item)
            }
        },
        mounted() {
        },
        methods: {
            showItemInFull(item) {
                if(this.hideItemDetails) {
                    return
                }

                this.$store.commit('updateSelectedItem', JSON.parse(JSON.stringify(item)))
                this.$store.commit('updateShowSelectedItemVariationSelection', true)
            },
            itemTranslatedDescriptionValue(item) {
                return this.$store.getters.translateByType('item.description.value', item)
            },
            itemDescription(item) {
                if(!this.itemIsAvailableForOrdering) {
                  return `<span class="text--disabled">${this.$t('errors.itemCurrentlyNotAvailable')}</span>`
                }

                if(item.description && this.itemTranslatedDescriptionValue(item)) {
                    return this.itemTranslatedDescriptionValue(item)
                }

                return ''
            },
            currencyAsText(amount) {
                // To handle products with no price but multiple variation prices
                if(amount && amount.toString().includes(' - ')) {
                    return amount
                }

                const price = {
                    amount: amount,
                    currency_code: this.item.price.currency_code
                }

                return this.$store.getters.currencyAsText(price)
            },
        }
    }
</script>

<style scoped>
    .salescloud-item-description p {
        display: inline;
    }
</style>
